import { render } from "./SuperAssistant.vue?vue&type=template&id=17b6f232&scoped=true"
import script from "./SuperAssistant.vue?vue&type=script&lang=js"
export * from "./SuperAssistant.vue?vue&type=script&lang=js"

import "./SuperAssistant.vue?vue&type=style&index=0&id=17b6f232&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b6f232"]])

export default __exports__